import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Search params: filtr na lektora („Moje termíny" dlaždice) + měsíc kalendáře
 * („YYYY-MM"), ať se pohled po návratu z karty termínu neresetuje.
 * Neplatné hodnoty tiše zahodíme.
 */
const terminySearchSchema = z.object({
  lektorId: z.string().max(255).optional().catch(undefined),
  mesic: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/dashboard/terminy")({
  validateSearch: (search) => terminySearchSchema.parse(search),
  beforeLoad: requirePermissionGuard("hca.terminy.read"),
});
